import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import SDElementsMappingForm from "./SDElementsMappingForm";
import SDElementsCredentialsForm from "./SDElementsCredentialsForm";
import { columnRenderArrayData } from "utils/tableUtils";

const columns = [
  {
    title: "Application Name",
    dataIndex: "applicationName",
    width: 240,
  },
  {
    title: "Project",
    dataIndex: "projectName",
    width: 240,
    render: columnRenderArrayData,
  },
  {
    title: "Countermeasure Relevance",
    dataIndex: "relevant",
    width: 100,
  },
];

export default function SDElementsConfigListing(props) {
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={SDElementsMappingForm}
      CredentialsForm={SDElementsCredentialsForm}
      extraColumns={columns}
    />
  );
}
